import InjectionProperty from "./InjectionProperty.js";

export default class InjectionProperties {
    /**
     * These properties cannot be changed
     * We can determine which properties were overridden when compare new JSON with these props
     * @type {{[key: string]: any}}
     */
    #rawProperties;
    /** @type {InjectionProperty[]} */
    #propertiesForDisplay;

    /**
     * @param {{[key: string]: any}} userProperties
     * @param {{[key: string]: any}} rawProperties
     */
    constructor(userProperties, rawProperties) {
        this.#rawProperties = rawProperties;
        this.#propertiesForDisplay = InjectionProperties.createProps(userProperties, rawProperties);
    }

    /** @returns {{[key: string]: any}}} */
    get rawProperties(){
        return this.#rawProperties;
    }

    /** @returns {InjectionProperty[]} */
    get propertiesForDisplay(){
        return this.#propertiesForDisplay;
    }

    /** @param {{[key: string]: any}} userProperties */
    setUserProperties(userProperties) {
        this.#propertiesForDisplay = InjectionProperties.createProps(userProperties, this.#rawProperties);
    }

    /**
     * @param {{[key: string]: any}} props
     * @returns {{[key: string]: any}}
     */
    filterUserDefinedProps(props){
        const result = {};
        for (const key in props) {
            if (this.#rawProperties[key] === undefined || this.#rawProperties[key] !== props[key]){
                result[key] = props[key];
            }
        }
        return result;
    }

    /**
     * @param {{[key: string]: any}} props
     * @returns {{[key: string]: any}}
     */
    createServerPropsAndSaveNewProperties(props){
        const result = this.filterUserDefinedProps(props)
        this.setUserProperties(result);
        return result;
    }

    /**
     * @param {{[key: string]: any}} userDefinedProps
     * @param {{[key: string]: any}?} rawProps
     */
    static createProps(userDefinedProps, rawProps = {}){
        const result = [];
        for (const key in userDefinedProps) {
            const isOverridden = rawProps[key] !== undefined;
            if (isOverridden && rawProps[key] === userDefinedProps[key]) {
                continue
            }
            const type = isOverridden ? InjectionProperty.TYPE.OVERRIDDEN : InjectionProperty.TYPE.USER_DEFINED;
            result.push(new InjectionProperty(key, userDefinedProps[key], type, rawProps[key]));
        }
        for (const key in rawProps) {
            if (result.find(p => p.name === key) === undefined)
                result.push(new InjectionProperty(key, rawProps[key], InjectionProperty.TYPE.RAW, rawProps[key]));
        }
        return result;
    }
}